module.exports = __webpack_public_path__ + "img/treasure-hide.25bc62cb.png";